export default __webpack_public_path__ + "static/media/bkg--home-1.141c5d83.jpg";